<script lang="ts" setup>
import { useFetch } from '@/home/hooks/fetch';
import { useAsyncData } from '@/home/hooks/async-data';

const { $fetch } = useFetch();

const { data: imgList } = useAsyncData(
  'home:operation',
  () => $fetch('/operator/getOperatorList', { method: 'post', data: { operateType: 3, pageSize: 3 } }),
);
</script>

<template>
  <div class="pt-80">
    <div class="mt-46 flex gap-20" v-if="imgList?.length">
      <li v-for="item in imgList" :key="item.jumpUrl" class="list-none">
        <a :href="item.jumpUrl" target="_blank">
          <img :src="item.picUrl" class="h-258 w-386 rounded-16 object-cover" :alt="item.operateName" :title="item.operateName">
        </a>
      </li>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
